module.exports = __webpack_public_path__ + "img/loto-4-59-luckia-mobile.b37204b9.png";